import { Grid, Link, Typography } from "@mui/material";
import { useFindLicensesForUserQuery } from "../../api/api-hooks";
import { useHistory } from "react-router";
import { useSoftwareTypeMap } from "../../hooks/useSoftwareTypeMap";

const SoftwareSupportDisplay = () => {
  const { data: licenses } = useFindLicensesForUserQuery({});
  const { push } = useHistory();
  const typeMap = useSoftwareTypeMap();
  if (licenses === undefined) return null;
  const sortedLicenses = [...licenses].sort((item1, item2) =>
    item1.software.type.localeCompare(item2.software.type)
  );
  const softwareTypeIds = sortedLicenses.map((license) => license.softwareId);
  const uniqueSoftwareTypeIds = softwareTypeIds.reduce(
    (acc: number[], cur) => (acc.includes(cur) ? acc : acc.concat([cur])),
    []
  );
  return (
    <Grid container direction="column" spacing={1} alignItems="flex-start">
      <Grid item>
        <Typography variant="h6">Software</Typography>
      </Grid>
      {uniqueSoftwareTypeIds.map((item) => (
        <Grid item key={item}>
          <Link
            href={`/software/${item}`}
            onClick={(event: any) => {
              event.preventDefault();
              push(`/software/${item}`);
            }}
            underline="hover">
            {typeMap.get(item)}
          </Link>
        </Grid>
      ))}
    </Grid>
  );
};

export default SoftwareSupportDisplay;
